
import BlankLayout from './BlankLayout'

export { BlankLayout }
